import React from "react";

interface GradientButtonProps {
  label: string;
  onPress: () => void;
  className?: string;
}

export const GradientButton: React.FC<GradientButtonProps> = ({
  label,
  onPress,
  className,
}) => {
  return (
    <button onClick={onPress} className={`gradient-button ${className || ""}`}>
      {label}
    </button>
  );
};
